import { createFileRoute } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';

import { PageSkeleton } from '~/components/common/page-skeleton/page-skeleton';

const MetaScheduleWizardPage = lazy(
  () => import('~/features/content-enrichment/pages/meta-schedule-wizard-page'),
);

/** `?scheduleId=` edits that schedule's settings; without it a new schedule is set up. */
interface ScheduleWizardSearch {
  scheduleId?: string;
}

/** The Meta Ads batch wizard in schedule mode.
 *  URL: `/enrichments/meta/schedule`. Contract-gated via the parent layout. */
export const Route = createFileRoute('/_authenticated/_tenant/enrichments/meta/schedule')({
  validateSearch: (search: Record<string, unknown>): ScheduleWizardSearch =>
    typeof search.scheduleId === 'string' && search.scheduleId
      ? { scheduleId: search.scheduleId }
      : {},
  component: RouteComponent,
});

function RouteComponent() {
  const { scheduleId } = Route.useSearch();
  return (
    <Suspense fallback={<PageSkeleton />}>
      <MetaScheduleWizardPage {...(scheduleId ? { scheduleId } : {})} />
    </Suspense>
  );
}
